import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatDialogRef, MatSnackBar, MAT_DATE_FORMATS, MAT_DIALOG_DATA } from '@angular/material';
import Swal from 'sweetalert2';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../../core/format-datepicker';
import { RescheduleAppointmnet } from '../../../core/model/v2/appointment/reschedule-appointment';
import { AppointmentsService } from '../../../core/services/v2/appointments.service';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { UtilsService } from '../../../core/services/v2/utils.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';
@Component({
  selector: 'app-reschedule-appointment',
  templateUrl: './reschedule-appointment.component.html',
  styleUrls: ['./reschedule-appointment.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }]
})
export class RescheduleAppointmentComponent implements OnInit {
  rescheduleAppointmentForm: FormGroup;
  dateSelect: boolean = false;
  minDate: Date = new Date();
  practitionerData: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RescheduleAppointmentComponent>,
    private loaderService: WindowLoaderService,
    private appointmentsService: AppointmentsService,
    private practiceService: PracticeService,
    private fb: FormBuilder,
    private _util: UtilsService) { }

  ngOnInit() {
    this.practitionerData = this.data.appt.practitioner;
    this.rescheduleAppointmentForm = this.fb.group({
      appointmentId: [this.data.appt.id, Validators.required],
      date: ['', Validators.required],
      requestedSlot: ['', Validators.required],
      urgencyType: ['', Validators.required]
      //healthSystemId: ['', Validators.required]
    });
  }

  onUrgencyChange(event: any) {
    if (event.target.value == 'Select Date') {
      this.dateSelect = true;
    }
    else {
      this.rescheduleAppointmentForm.controls.date.setValue(new Date());
      this.dateSelect = false;
    }
  }

  rescheduleAppointment() {
    const res = this.validateAppointment();
    if (!res) {
      return;
    }
    let formData = this.rescheduleAppointmentForm.getRawValue();
    let appointmentDate = this.getFormatedDate(new Date());
    if (formData.urgencyType == 'Select Date') {
      appointmentDate = this.getFormatedDate(formData.date);
    }

    const rescheduleApptObj: RescheduleAppointmnet = {
      appointmentId: formData.appointmentId,
      appointmentDate: appointmentDate,
      requestedSlot: formData.requestedSlot
    };

    this.loaderService.blockWithLoader(this.appointmentsService.rescheduleAppointment(rescheduleApptObj)).subscribe(
      (data) => {
        if (data.response.isSuccess) {
          this.dialogRef.close({ success: true });
        }
        else {
          this.dialogRef.close({ success: false });
          Swal.fire(
            'Sorry!',
            data.response.message,
            'error'
          )
        }
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
        this.dialogRef.close({ success: false });
      }
    );
  }

  private getFormatedDate(date: Date) {
    if (!date) {
      return null;
    }
    let day = ('0' + date.getDate()).slice(-2);
    let month = ('0' + (date.getMonth() + 1)).slice(-2);

    let year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  validateAppointment(): boolean {
    let errorMessageList = [];
    if (!this.rescheduleAppointmentForm.controls.urgencyType.valid) {
      errorMessageList.push('Please select urgency type.');
    }
    if (!this.rescheduleAppointmentForm.controls.requestedSlot.valid) {
      errorMessageList.push('Please select Slot.');
    }
    if (this.rescheduleAppointmentForm.controls.urgencyType.valid && this.rescheduleAppointmentForm.controls.urgencyType.value === 'Select Date') {
      if (!this.rescheduleAppointmentForm.controls.date.value) {
        errorMessageList.push('Please select Appointment Date.');
      }
    }

    if (errorMessageList.length > 0) {
      this.rescheduleAppointmentForm.markAllAsTouched();
      this._util.showMessageSnackBar(errorMessageList.join('\r\n'), true);
      return false;
    }

    return true;
  }
  cancel() {
    this.dialogRef.close({ success: false });
  }

}
